import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { HuvudB2 } from '../../interfaces/huvudB2.interface';
import { Attest } from '../../interfaces/attest.interface';

@Injectable()
export class HuvudB2Service {
  constructor(
    protected http: HttpClient,
    @Inject('API_URL') protected apiUrl: string) {
  }

  public getHuvudB2(instance: string, id: string): Observable<HuvudB2> {
    return this.http.get<HuvudB2>(`${this.apiUrl}${instance}/huvudB2/get/${id}`);
  }
}
